import { afterNextRender, AfterViewInit, Component, DestroyRef, effect, inject, model, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Product } from '../../../../generated/generated-types';
import { ProductPriceEditWidgetComponent } from '../product-price-edit-widget/product-price-edit-widget.component';

@Component({
  selector: 'app-formly-product-price-edit',
  templateUrl: './formly-product-price-edit.component.html',
  standalone: true,
  imports: [
    ProductPriceEditWidgetComponent,
    TranslatePipe,
  ]
})
export class FormlyProductPriceEditComponent extends FieldType<FieldTypeConfig> implements AfterViewInit {
  destroyRef = inject(DestroyRef);

  product = model<Product>(null);

  dataTestid = signal<string>("formly-product-price-edit");

  constructor() {
    super();
    effect(() => {
      this.product.set(this.model);
      // console.log('productId', this.product()?.id);
    });
    afterNextRender({
      read: () => {
        this.form?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((x) => {

          //technically we only need to track changes for productId or priceReferenceProductId

          this.product.set(this.model);
        });
      }
    },);
    // this.destroyRef.onDestroy(() => {
    //   console.log(`Destroying ${this.constructor.name}...`);
    // });
  }

  ngAfterViewInit(): void {
    this.dataTestid.set(this.props.attributes['data-testid'].toString());
  }
}
